enum TrackingStatus {
  ON_THE_WAY = 'on the way',
  DELIVERED = 'delivered',
  ALERT = 'alert',
  NOT_DELIVERED = 'not delivered',
  EXPIRED = 'expired',
}
export default TrackingStatus;
